import React from 'react';
import PropTypes from 'prop-types';

import '../../style.scss';

const ModalHeader = ({ title, subtitle, icon, className }) => (
  <header
    styleName="modal__header"
    className={className}
    data-test="modal-header"
  >
    {icon && (
      <span styleName="modal__icon" data-test="modal-header-icon">
        {icon}
      </span>
    )}
    {subtitle ? (
      <div styleName="modal__titles">
        <div styleName="modal__title" data-test="modal-title">
          {title}
        </div>
        <div styleName="modal__subtitle">{subtitle}</div>
      </div>
    ) : (
      <p data-test="modal-title" styleName="modal__title">
        {title}
      </p>
    )}
  </header>
);

ModalHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  icon: PropTypes.node,
  className: PropTypes.string,
};

ModalHeader.defaultProps = {
  subtitle: null,
  icon: null,
  className: '',
};

export default ModalHeader;
